import React from "react";
import { Routes, Route } from "react-router";

// Layouts
import { RootLayout } from "../layouts/RootLayout";
import { AuthLayout } from "../layouts/AuthLayout";
import { ProtectedLayout } from "../layouts/ProtectedLayout";

// Pages
import {
  FAQsPage,
  HomePage,
  MyFavouritesPage,
  PrivacyPolicyPage,
  SettingsPage,
  SignInPage,
  OTPVerificationPage,
  StorePage,
  ProductPage,
  MyCartPage,
  PaymentPage,
  OrderSuccessPage,
  MyProfilePage,
  MyOrdersPage,
  NotFoundPage,
  OrderDetailPage,
  PersonalDetailsPage,
  PaymentFailurePage,
  TermsAndConditionsPage,
  CancellationAndRefundPolicyPage,
  ContactUsPage,
} from "@nusrif/ui/client";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route index element={<HomePage />} />
        <Route path="store" element={<StorePage />} />
        <Route path="product/:id" element={<ProductPage />} />
      </Route>
      
      <Route element={<AuthLayout />}>
        <Route path="signin" element={<SignInPage />} />
        <Route path="otp-verification" element={<OTPVerificationPage />} />
        <Route path="profile/faqs" element={<FAQsPage />} />
        <Route path="profile/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="profile/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="profile/cancellation-and-refund-policy" element={<CancellationAndRefundPolicyPage />} />
        <Route path="profile/contact-us" element={<ContactUsPage />} />
      </Route>
      
      <Route element={<ProtectedLayout />}>
        <Route path="cart" element={<MyCartPage />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="order-success" element={<OrderSuccessPage />} />
        <Route path="payment-failure" element={<PaymentFailurePage />} />
        <Route path="profile" element={<MyProfilePage />} />
        <Route path="profile/personal-details" element={<PersonalDetailsPage />} />
        <Route path="profile/my-orders" element={<MyOrdersPage />} />
        <Route path="profile/my-orders/:orderId" element={<OrderDetailPage />} />
        <Route path="profile/my-favourites" element={<MyFavouritesPage />} />
        <Route path="profile/settings" element={<SettingsPage />} />
      </Route>
      
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}; 